import { IUser } from 'interfaces/user'
import { User } from '@/shared/interfaces/user'
import { environment } from '../consts/environment'

export const checkAuthorizedUser = (user: User | IUser) => {
  if (environment.env === 'development') return true
  if (user.email?.includes('creatorland.com')) {
    return true
  }
  if (user.email?.includes('freedom.tm')) {
    return true
  }
  if (user.email?.includes('polyform.co')) {
    return true
  }
  if (user.email?.includes('pixeltrue.com')) {
    return true
  }
  if (user.authorized) {
    return true
  }
  if (
    typeof user?.referringUserID === 'string' &&
    user?.referringUserID !== 'undefined'
  ) {
    return true
  }
  if (user?.subscribed) {
    return true
  }

  return false
}
